import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

function useInventoryNotesSummary(params) {
  const { skip, limit, page, ...filterParams } = params || {};

  return useSWR(
    {
      path: "/api/v1/inventory-notes/summary",
      method: "GET",
      params: filterParams,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryNotesSummary;
